import axios, { AxiosRequestConfig, AxiosResponse } from 'axios';

const getBaseUrl = () => {
  if (window.location.hostname.includes(".fr")) {
    return "https://portal.wall-of-share.fr";
  } else {
    return "https://portal.wall-of-share.com";
  }
};

export const baseURL= getBaseUrl();

// export const  baseURL = 'https://portal.wall-of-share.com';
// export const  baseURL = 'https://www.wall-of-share.com';
// export const  baseURL = process.env.REACT_APP_API_ROOT_URL || 'https://wall-of-share.com';
// export const  baseURL = 'https://wall-of-share.com';

const axiosInstance = axios.create({
  baseURL,
  timeout: 40000,
  headers: {
    'Content-Type': 'application/json',
  },
});

type ApiResponse<T> = Promise<AxiosResponse<T>>;

/**
 * GET request
 * @param url - The endpoint URL
 * @param params - Query parameters (optional)
 * @param config - Additional Axios configuration (optional)
 * @returns - Axios response promise
 */
export const get = <T>(
  url: string,
  params?: Record<string, any>,
  config?: AxiosRequestConfig
): ApiResponse<T> =>
  axiosInstance.get<T>(url, { params, ...config });

/**
 * POST request
 * @param url - The endpoint URL
 * @param data - Request body
 * @param config - Additional Axios configuration (optional)
 * @returns - Axios response promise
 */
export const post = <T>(
  url: string,
  data: Record<string, any>,
  config?: AxiosRequestConfig
): ApiResponse<T> =>
  axiosInstance.post<T>(url, data, config);

/**
 * PUT request
 * @param url - The endpoint URL
 * @param data - Request body
 * @param config - Additional Axios configuration (optional)
 * @returns - Axios response promise
 */
export const put = <T>(
  url: string,
  data: Record<string, any>,
  config?: AxiosRequestConfig
): ApiResponse<T> =>
  axiosInstance.put<T>(url, data, config);

/**
 * PATCH request
 * @param url - The endpoint URL
 * @param data - Request body
 * @param config - Additional Axios configuration (optional)
 * @returns - Axios response promise
 */
export const patch = <T>(
  url: string,
  data: Record<string, any>,
  config?: AxiosRequestConfig
): ApiResponse<T> =>
  axiosInstance.patch<T>(url, data, config);

/**
 * DELETE request
 * @param url - The endpoint URL
 * @param params - Query parameters (optional)
 * @param config - Additional Axios configuration (optional)
 * @returns - Axios response promise
 */
export const del = <T>(
  url: string,
  params?: Record<string, any>,
  config?: AxiosRequestConfig
): ApiResponse<T> =>
  axiosInstance.delete<T>(url, { params, ...config });


export default  {
    get,
    post,
    del,
    put,
    patch
}